//双语规范的变量(英文)

export const enm = {

  'index': 'Agent Platform',
  'Login':'Login',
  'User_Name1':'UserName',
  'User_Name2':'UserName',
  'User_Name3':'UserName',
  'User_Name4':'Operated',

  'Password1':'Password',
  'Password2':'Password',

  'agent_list':'agent list',
  'Add_Agent':'Add Agent',
  'new_store':'New store',

  'Agent_total_report':'Agent total report',
  'Reload_agent_List':'Reload agent List',
  'Set_score2':'Set score',
  'Name2':'Name',
  'Tel':'Tel',
  'Description1':'Description',
  'Description2':'Description',
  'Cancel':'Cancel',
  'OK2':'OK',
  'Score':'Score',
  'Name1':'Name',
  'Operation':'Operation',
  'Set_score1':'Set score',
  'score_log':'Score log',
  'edit':'Edit',
  'report':'Report',
  'disable':'Disable',
  'enable':'Enable',
  'player_list':'player list',
  'Add_Player':'Add Player',
  'User_agent':'User agent',
  'Player_total_report':'Player total report',
  'Enable_all_player':'Enable all player',
  'Disable_all_player':'Disable all player',
  'Confirm_ban_all_players':'Are you sure to disable all players?',
  'Confirm_enable_all_players':'Are you sure to enable all players?',
  'Confirm_ban_proxy':'Are you sure to disable this agent?',
  'Confirm_enable_proxy':'Are you sure to enable this agent?',
  'Confirm_ban_user':'Are you sure to disable this player?',
  'Confirm_enable_user':'Are you sure to enable this player?',
  'Cannot_ban_self':'Cannot disable yourself',
  'Reload_player_List':'Reload player List',
  'Last_login_time':'Online',
  'game_log':'Game log',
  'Bonus_log':'Bonus log',
  'Change_Password':'Change password',
  'Old_password':'Old password',
  'New_password':'New password',
  'Please_enter_your_old_password':'Please enter your old password',
  'Please_enter_your_password':'Please enter your password',
  'Please_confirm_your_new_password':'Please confirm your new password',
  'OK1':'OK',
  'Confirm_new_password':'Confirm new password',
  'Please_enter_your_account_number':'Please enter your account number',
  'The_length_is_716_characters':'The length is 7-16 characters',
  'Username_format_hint':'Please enter letters, numbers or a combination',
  'The_length_is_616_characters':'The length is 6-15 characters',
  'Password_format_hint_strict':'Password with minimum 6 digit, must with combination of numbers and alphabets. At least a capital letter and a small letter. May have !-_ symbols.',
  'Password_format_hint':'Password with minimum 6 digit, must with combination of numbers and alphabets. May have !-_ symbols.',
  'Password_no_consecutive':'You cannot enter more than 3 consecutive numbers and letters.',
  'Please_enter_a_score':'Please enter a score',
  'Score_must_be_numeric':'Please enter a numeric value',
  'Please_enter_a_numeric_value':'personal(2nd security) password must be at 6 digits, and cannot be too simple.',
  'Please_enter_the_2nd_security_password':'Please enter the 2nd security password.',
  'Please_enter_the_correct_score_format':'Please enter the correct score format',
  'Enter_up_to_two_decimal_places':'Enter up to two decimal places',
  'Enter_up_to_three_decimal_places':'Enter up to three decimal places',
  'Get_data_successfully':'Get data successfully',
  'Failed_to_get_agent':'Failed to get agent',
  'Exceeding_the_maximum_value':'Exceeding the maximum value',
  'Score_must_be_positive':'Creation failed, the score setting needs to be greater than 0',
  'Add_successfully':'Add successfully',
  'Failed_to_add_agent':'Failed to add agent',
  'Failed_to_get_player':'Failed to get player',
  'Failed_to_add_player':'Failed to add player',
  'Modification_successful':'Modification successful',
  'Modification_failed':'Failed',
  'Successful_operation':'Successful operation',
  "Personal_secondary_security_password": "Personal secondary security password",
  "Confirm_personal_secondary_security_password": "Confirm personal secondary security password",
  "Personal_secondary_password": "Personal secondary password",

  'Please_select':'Please select',
  'Private_password_info': 'For security reasons, please set your secondary security password and reconfirm it each time you log in. The administrator cannot view or edit your secondary security password. If you forget or enter the wrong password 5 times, please contact the administrator to request a new secondary security password. After resetting, please change your secondary security password immediately. Your secondary security password must be at least 6 digits long and cannot be too simple.',

  'Password_mismatch':'Failed! The two passwords do not match',
  "Password_same_as_old": "The new password is the same as the old password",
  "Password_mismatch_error": "Failed, the two passwords entered are not the same.",
  "Password_used_before": "Failed, the password has been used before.",
  "Change_success_relogin": "Success! Tap 'Confirm' to re-login.",
  'my_score':'my score',
  "Confirm_Logout": "Confirm Logout?",
  'Sign_out':'Sign out',
  "Logged_out": "Logged out",
  "Add_failed": "Add failed",
  "personal_2_Password": "personal(2nd security) Password",
  "Login_Failed": "Login Failed",
  'Old_personal2_password':'Old personal(2nd security) password',
  'New_personal2_password':'New personal(2nd security) password',
  'Confirm_new_personal2_password':'Confirm new personal(2nd security) password',
  'Change_personal_2_Password':'Change personal Pwd',
  'Current_score':'Current score',
  'Score_nonzero_hint':'Please enter a number greater than 0 or less than 0',
  'Successful_operation1':'Successful operation',
  "Failed_Operation": "Failed Operation",
  'Player_Records':'Player Records',
  'Agent_Records':'Agent Records',
  'Player_Account':'Player Account',
  'Agent_Account':'Agent Account',
  'Select_Date':'Select Date',
  'TO':'TO',
  'Start_date':'Start date',
  'End_date':'End date',
  'Account2':'Account',
  'Before_Score':'Before Score',
  'After_Score':'After Score',
  'Date_Time1':'Date Time',
  'Date_Time2':'Date Time',
  "The_length_is_8_characters": "The length is 8 characters.",
  "Last_week": "Last week",
  "Last_month": "Last month",
  "Last_three_months": "Last three months",
  "Please_enter_the_time": "Please enter the time",
  'No_Data':'No Data',
  "Failed_to_obtain_data": "Failed to obtain data",
  'Total_win':'Total win',
  'Win':'Win',
  "agent": "Agent",
  'Game_Name':'Game Name',
  'Begin_Money':'Begin score',
  'Bet':'Bet',
  'End_Money':'End score',
  'Bonus_Amount':'Bonus Amount',
  "Functional_Description": "Functional Description",
  "Enable_the_function": "Enable the function",
  "Creation_Date": "Creation Date",
  "Modify_permissions": "edit",

  "Is_auditing_enabled": "Enable account checking?",
  "Is_to_score": "Set score?",
  "Can_new_account": "Add a new account?",
  "Is_disable_unban_account": "Disable/enable account?",
  "Can_edit_account": "Edit Account?",
  "Is_disable_unban_sub_accounts": "Disable/enable sub-account?",
  "Allow_audit":"Check total report",
  "Allow_to_score":"Set score",
  "Allow_new_accounts":"Add account",
  "Allow_disabling_unbanning_accounts":"Disable/enable account",
  "Allow_account_editing":"Edit Account",
  "Allow_disabling_unbanning_subaccounts":"Disable/enable sub-account",
  "Please_select_permissions": "Please select permissions",

  "Action_Type": "Action Type",
  "Operator": "Operator",
  "Operated": "Operated",
  "Set_score_player": "Set scores for player",
  "Set_score_agent": "Set scores for agent",
  "Add_players": "Add new player",
  "Add_NEW_Agent": "Add new agent",
  "Add_subaccount": "Add sub-accounts",
  "Unban_all_players": "Enable all player",
  "Ban_All_Players": "Disable all player",
  "Unban_players": "Enable a single account",
  "Ban_Player": "Disable a single account",
  "Edit_Player_Information": "Edit user",
  "Edit_Agent_Information": "Edit agent",
  "Unban_single_agent": "Unban a single agent",
  "ban_single_agent": "ban a single agent",
  "Sub_account": "Sub-account",
  'user_management':'User management',
  "Edit_User": "Edit user",
  'Edit_agent':'Edit agent',
  "General_ledger_audit": "General ledger audit",
  "Search_Account": "Search account",
  'Operation_log':'Operation log',
  "Sub_account_management":"Sub-account",
  "Modify_subaccount_permissions": "Modify sub-account permissions",

  "act_1_1": "Give the player a score: ",
  "act_1_2": " --- for account: ",
  "act_1_3": " Set score control successfully, score: ",
  "act_1_4": " Agent's previous score: ",
  "act_1_5": " Now: ",

  "act_2_1": "Give the agent a score: ",
  "act_2_2": " --- for account: ",
  "act_2_3": " Set score control successfully, score: ",
  "act_2_4": " Agent's previous score: ",
  "act_2_5": " Now: ",

  "act_3_1": "Add player: ",
  "act_3_2": " --- Add account: ",
  "act_3_3": "successfully",

  "act_4_1": "Add agent: ",
  "act_4_2": " --- Add agent: ",
  "act_4_3": "successfully",

  "act_5_1": "Add sub-account: ",
  "act_5_2": " --- Add sub-account: ",
  "act_5_3": "successfully",

  "act_6_1": "Enable all players: ",
  "act_6_2": " --- Enabled: ",
  "act_6_3": "all players successfully",

  "act_7_1": "Disable all players: ",
  "act_7_2": " --- Disable: ",
  "act_7_3": " all players successfully",

  "act_8_1": "Enable a single account: ",
  "act_8_2": " --- Enable account: ",
  "act_8_3": "Successfully",

  "act_9_1": "Disable a single account: ",
  "act_9_2": " --- Disable account: ",
  "act_9_3": "Successfully",

  "act_10_1": "Edit account information: ",
  "act_10_2": " --- Update player account: ",
  "act_10_3": " information successfully",

  "act_11_1": "Edit account information: ",
  "act_11_2": " --- Update agent account: ",
  "act_11_3": " information successfully",

  "Limit_reached": "The limit for creating agents has been reached",

  "The_length_is_6_characters": "The length is 6 characters.",
  "Private_password_hint": "The private password (secondary password) must be 6 pure digits and cannot be too simple",
  "UserId_must_be_7_digits": "must be 7 pure digits",
  "Begin_Date": "Begin Date",
  "End_Date": "End Date",
  "Select_date": "Select date",
  "Select_time": "Select time",
  "AgentList_Menu": "AgentList Menu",
  "PlayerList_Menu": "PlayerList Menu",
  "DisOnlineDay": "DisOnlineDay",
  "Back": "Back",
  'The_length_is_11_characters':'The length is 11 characters',
  "days": "days",
  "off": "OFF: ",
  "online": "online",
  "table_id": "TableID",
  "ranking": "Rankings",
  "ranking1": "Ranking",
  "coding_volume": "bet",
  "reward": "reward",
  "Winning_time": "Winning time",
  "IP": "IP",
  "Total_pay": "Total Pay",
  "Total_withdraw": "Total Withdraw",

}



// WEBPACK FOOTER //
// ./src/lang/en.js